import {
  LeadAttributionGroupedEnum,
  LeadAttributionStatusEnum,
} from "../enums/account-lead-attribution.enum";

export const leadAttributionGroupColorMap: Record<
  LeadAttributionGroupedEnum,
  string
> = {
  [LeadAttributionGroupedEnum.VIEWINGS_BOOKED]: "#383F55",
  [LeadAttributionGroupedEnum.VALUATIONS_BOOKED]: "#6072B0",
  [LeadAttributionGroupedEnum.INSTRUCTIONS]: "#FF7495",
  [LeadAttributionGroupedEnum.COMPLETIONS]: "#FFA56F",
  // these ones are not defined in designs
  [LeadAttributionGroupedEnum.TENANCIES]: "leadpro.400",
  [LeadAttributionGroupedEnum.EXCHANGES]: "leadpro.400",
  [LeadAttributionGroupedEnum.OFFERS]: "leadpro.400",
  [LeadAttributionGroupedEnum.OTHERS]: "leadpro.400",
};

export const eventTypeToGroupMapping: Record<
  LeadAttributionStatusEnum,
  LeadAttributionGroupedEnum
> = {
  [LeadAttributionStatusEnum.VIEWING_BOOKED]:
    LeadAttributionGroupedEnum.VIEWINGS_BOOKED,

  [LeadAttributionStatusEnum.VALUATION_BOOKED]:
    LeadAttributionGroupedEnum.VALUATIONS_BOOKED,

  [LeadAttributionStatusEnum.OFFER_RECEIVED]: LeadAttributionGroupedEnum.OFFERS,

  [LeadAttributionStatusEnum.SELLING_INSTRUCTED_TO_MARKET]:
    LeadAttributionGroupedEnum.INSTRUCTIONS,
  [LeadAttributionStatusEnum.LETTING_INSTRUCTED_TO_MARKET]:
    LeadAttributionGroupedEnum.INSTRUCTIONS,

  [LeadAttributionStatusEnum.PROPERTY_EXCHANGED]:
    LeadAttributionGroupedEnum.EXCHANGES,

  [LeadAttributionStatusEnum.PROPERTY_COMPLETED]:
    LeadAttributionGroupedEnum.COMPLETIONS,
  [LeadAttributionStatusEnum.TENANCY_ACCEPTED]:
    LeadAttributionGroupedEnum.COMPLETIONS,

  [LeadAttributionStatusEnum.LEAD_CREATED]: LeadAttributionGroupedEnum.OTHERS,
  [LeadAttributionStatusEnum.LEAD_SYNCED]: LeadAttributionGroupedEnum.OTHERS,
  [LeadAttributionStatusEnum.UNDEFINED_STATUS]:
    LeadAttributionGroupedEnum.OTHERS,
  [LeadAttributionStatusEnum.OFFER_MADE]: LeadAttributionGroupedEnum.OTHERS,
  [LeadAttributionStatusEnum.OFFER_ACCEPTED]: LeadAttributionGroupedEnum.OTHERS,
  [LeadAttributionStatusEnum.TENANCY_REQUESTED_BY_CONTACT]:
    LeadAttributionGroupedEnum.OTHERS,
  [LeadAttributionStatusEnum.TENANCY_REQUESTED_TO_CONTACT]:
    LeadAttributionGroupedEnum.OTHERS,
};

export const groupToEventTypesMap = Object.freeze(
  Object.entries(eventTypeToGroupMapping).reduce((acc, [statusKey, group]) => {
    const status = statusKey as LeadAttributionStatusEnum;
    (acc[group] = acc[group] || []).push(status);
    return acc;
  }, {} as Record<LeadAttributionGroupedEnum, LeadAttributionStatusEnum[]>)
);
